var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('options-picker',{attrs:{"selected":_vm.value,"options":_vm.tags,"label":"Tags","display-field":"nome"},on:{"add":_vm.adicionarTag,"remove":_vm.removerTag}})}
var staticRenderFns = []

export { render, staticRenderFns }